module.exports = __webpack_public_path__ + "prod/1.42.2/img/44.79be20fa.svg";